import { CodPosition } from 'src/constants';

import { IStatus } from './Common';
import { ILayoutType } from './LayoutType';
import { GlobalComponentsScreenInterface } from './ProjectConfig';
import { IScreen, IScreenType } from './Screen';

export enum SectionTypes {
  COD = 'COD',
  CONFIRMATION = 'Confirmation',
  THANK_YOU = 'Thank You',
  DY = 'DY',
  DYS = 'DYS',
  DYR = 'DYR',
  DYP = 'DYP',
  SECTION_ROTATION = 'Section rotation',
  TAKE_OVER = 'Take Over',
  DEFAULT = 'Default',
}

export type TLayerTypes =
  | SectionTypes.DEFAULT
  | SectionTypes.SECTION_ROTATION
  | SectionTypes.TAKE_OVER;
interface IBaseLayout {
  id: number;
  name: string;
  status?: IStatus;
  layout_type_id: number;
  layoutType?: ILayoutType;
  channel_name: string;
  config?: ILayoutConfigData;
  cod_position?: CodPosition;
  created_at: string;
  modified_at: string;
}

export interface ILayout extends IBaseLayout {
  screens: IScreen[];
}

export interface ILayoutModuleType extends IBaseLayout {
  screens: IScreenType[];
}

export enum IDisclaimerWidth {
  HALF = 'Half',
  FULL = 'Full',
}

export enum IDisclaimerPosition {
  TOP = 'Top',
  BOTTOM = 'Bottom',
}

export enum IScreenOrientation {
  HORIZONTAL = 'Horizontal',
  VERTICAL = 'Vertical',
}

export enum IGridOptions {
  GRID_3X3 = '3 X 3',
  GRID_3X4 = '3 X 4',
  GRID_4X2 = '4 X 2',
}

export enum ISidebarStates {
  DEFAULT = 'default',
  ROTATION = 'rotation',
}

export interface ICanvasSection {
  config?: {
    events: {};
  };
  width: number;
  height: number;
  leftOffset: number;
  topOffset: number;
  cols: number;
  rows: number;
}

export interface ICreateSectionPayload {
  sections: ICanvasSection[];
  screen: IScreen;
  layoutId: string;
  layoutGridLine: string;
  sectionTypes?: SectionTypes[];
  codPosition?: CodPosition;
  globalComponentsScreen?: GlobalComponentsScreenInterface;
}

export interface ITakeoverSectionPayload {
  screen: IScreen;
}

export interface IDeleteSectionPayload {
  screen: IScreen;
}

export enum IResponseType {
  CARD = 'Card',
  MODAL = 'Modal',
  PAGE = 'Page',
}

export type GridOrientation = 'vertical' | 'horizontal';

export interface IGridDimensionsParams {
  orientation: GridOrientation | string;
  disclaimerPosition: string | null;
  disclaimerType: string | null;
  rows: number;
  cols: number;
  scale?: number;
}

export interface ILayoutConfig {
  orientation: string;
  rows: number;
  cols: number;
  disclaimerPosition: string | null;
  disclaimerType: string | null;
}

export interface ILayoutConfigData {
  sectionTypes?: SectionTypes[];
  gridLines?: string[];
  rotationGridLines?: string[];
  screenLayoutType?: string;
}
